/**
 * Normalises an Inertia form error value to a single string. Server errors arrive as
 * arrays (`errors.messages`) or strings; inputs want one message.
 */
export function firstError(error: string | string[] | undefined): string | undefined {
  if (!error) return undefined;
  return Array.isArray(error) ? error[0] : error;
}
